<template lang="pug">
.container.column
  el-card.card#detalhesOs__main-container
    div#detalhesOs__tabela-container(v-if="isTabelaOS" key="tabela")
      TabelaDetalheOS(:dados="dadosOS")#detalhesOs__tabela
    div.bgWhite#detalhesOs__grafico-container(v-if="!isTabelaOS" key="grafico")
      GraficoDetalheOS(:dados="dadosOS")#detalhesOs__grafico
  div#detalhesOs__radio-btn-container
    el-radio-group(v-model="isTabelaOS")
      el-radio-button(:label="false") Gráfico
      el-radio-button(:label="true") Tabela
  div#detalhesOs__btn-acao-container
    el-button(
        type="default",
        @click="voltar"
      )#detalhesOs__voltar-btn
        span Voltar
    el-button(
        type="primary",
        @click="exportarTabelaDetalhes(isTabelaOS)"
      ).primary#detalhesOs__exportar-btn
        i.fal.fa-file-csv
        span &nbsp Exportar

</template>

<script>

import { mapActions } from 'vuex'
import TabelaDetalheOS from '../components/os/TabelaDetalheOS'
import GraficoDetalheOS from '../components/os/GraficoDetalheOS'
import domtoimage from 'dom-to-image'
import format from '@/utils/utils'

export default {

  components: {
    TabelaDetalheOS,
    GraficoDetalheOS
  },

  data () {
    return {
      dadosOS: {},
      isTabelaOS: false,
      osId: 0
    }
  },
  async created () {
    this.osId = this.$route.params.id
    this.getOSData(this.osId)
  },

  methods: {
    ...mapActions({
      getDetalhesOs: 'relatoriosOs/getDetalhesOs',
      exportaCSVOSDetalhada: 'relatoriosOs/exportaCSVOSDetalhada',
      resetLoader: 'loader/resetLoader',
      setLoader: 'loader/setLoader'
    }),

    getOSData (id) {
      this.getDetalhesOs(id).then((res) => {
        this.dadosOS = res
      })
    },

    voltar () {
      this.$router.push('/relatorios/os')
    },

    exportarTabelaDetalhes (isTabelaOS) {
      if (!isTabelaOS) {
        this.setLoader()
        const that = this
        let exportDate = this.formatDate(new Date(), 'DD/MM/YYYY_HH:mm:ss')
        domtoimage.toBlob(document.getElementById('detalhesOs__grafico-container'))
          .then(function (blob) {
            window.saveAs(blob, 'Grafico_OS_Detalhada' + exportDate + '.png')
            that.resetLoader()
          })
      } else {
        this.exportaCSVOSDetalhada(this.osId)
      }
    },

    formatDate (data, formato) {
      return format.formatDate(data, formato)
    }

  },

  watch: {
    'isTabelaOS' (val, oldVal) {
      if (val !== oldVal) {
        this.getOSData(this.osId)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_variables.scss';
.column {
  display: flex;
  flex-direction: column;
}

#detalhesOs__radio-btn-container {
  margin: 0 auto;
  position: relative;
  top: -50px;
  margin-bottom: -30px;
}

#detalhesOs__btn-acao-container {
  padding: 0 33px;
  display: flex;
  justify-content: space-between;
}

#detalhesOs__voltar-btn {
  background-color: #dcdcdc;
}

.bgWhite {
  background-color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/os/DetalhesOS.vue